import React from "react";
import Header from "./components/Header";
import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Footer from "./components/Footer";
import Projects from "./pages/Projects";
import ScrollTop from "./components/ScrollTop";
const App = () => {
  return (
    <>
      <Router>
        <Header />
        {/* Page Routes Here */}
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </Router>
      <Footer />
    </>
  );
};

export default App;
